import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=56f110d0&scoped=true"
import script from "./ProductsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=56f110d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f110d0",
  null
  
)

export default component.exports